import { useAuth0 } from "@auth0/auth0-react";
import React from "react";
import "./LoginButtonStyles.css";
import { endSession } from "../../middleware/session";

interface LoginButtonProps {}

const LoginButton: React.FC<LoginButtonProps> = () => {
	const { isAuthenticated, logout, loginWithRedirect } = useAuth0();


	async function LogInUser() {
		await loginWithRedirect();
	}

	function LogOutUser() {
		endSession(logout);
	}

	return (
		<>
			{isAuthenticated && (
				<button className="log-style" id="button-login-logout" onClick={() => LogOutUser()}>
					Logout
				</button>
			)}
			{!isAuthenticated && (
				<button className="log-style" id="button-login-logout" onClick={() => LogInUser()}>
					Log In / Sign Up
				</button>
			)}
		</>
	);
};

export default LoginButton;
